import {
    FormControlLabel,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
} from '@mui/material';
import { env } from '../../../../env';
import { EtabInfosPaginationDto } from '../../../../services/dtos/etab-infos-pagination.dto';
import { EtabInfosDto } from '../../../../services/dtos/etab-infos.dto';
import { createEtablissementVisibilite } from '../../../../services/etablissement-information.service';
import { getValueLocalStorage } from '../../../../hooks/use-local-storage.hook';

/**
 * Composant du tableau des pages
 * @param props Pages à afficher
 * @constructor
 */
export default function EtabInfosTable(props: {
    etablishments?: EtabInfosPaginationDto | null;
    searching: boolean;
    handleSwitchPageNumber(newPage: number): void;
    page: number;
}) {
    // Nombre de lignes par page, géré par une variable d'environnement
    const rowsPerPage = Number(env.REACT_APP_NUMBER_ELEMENT_TABLE);
    // En-têtes des cellules du tableau
    const headCells = [
        {
            id: 'etablishment',
            label: 'Etablissement',
            sort: false,
        },
        {
            id: 'visible',
            label: "Visibilité de l'établissement",
            sort: false,
        },
    ];

    /**
     * Gestion du changement de page
     * @param event Événement
     * @param newPage Page à afficher
     */
    const handleOnPageChange = async (event: any, newPage: number) => {
        event.preventDefault();
        props.handleSwitchPageNumber(newPage);
    };

    const handleChangeVisibilite = (e: any, etablissement: EtabInfosDto) => {
        const newValue: boolean = e.target.checked;
        const dateNow: Date = new Date();
        const user = getValueLocalStorage('user');
        createEtablissementVisibilite(etablissement.id, dateNow, newValue, 'compte_abonnes/' + user.userId);
    };

    return (
        // Container du tableau
        <TableContainer component={Paper}>
            {/*// Affichage du tableau*/}
            <Table>
                <TableHead>
                    <TableRow>
                        {/*En-têtes*/}
                        {headCells.map(headCell => (
                            <TableCell key={headCell.id} align={'left'} sx={{ fontWeight: 'bold', fontSize: 'medium' }}>
                                {headCell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        // Lignes du tableau
                        props.etablishments &&
                            props.etablishments?.etablissements?.map(etab => (
                                <TableRow key={etab.id}>
                                    <TableCell>{etab.designationOfficielle}</TableCell>
                                    <TableCell>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    value={etab.visible}
                                                    defaultChecked={etab.visible}
                                                    onClick={e => handleChangeVisibilite(e, etab)}
                                                />
                                            }
                                            label="Télérelève"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                    }
                </TableBody>
                <TableFooter>
                    <TableRow>
                        {/*Options de pagination*/}
                        <TablePagination
                            count={props.etablishments?.totalItems ? props.etablishments?.totalItems : 0}
                            onPageChange={handleOnPageChange}
                            page={props.page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[rowsPerPage]}
                            labelDisplayedRows={({ from, to, count }) => `${from} à ${to} sur ${count}`}
                            showFirstButton
                            showLastButton
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
